import { render, staticRenderFns } from "./insidecopper.vue?vue&type=template&id=22652d1e&scoped=true"
import script from "./insidecopper.vue?vue&type=script&lang=js"
export * from "./insidecopper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22652d1e",
  null
  
)

export default component.exports